const onDOMReady = (callback) => {
  if (document.readyState !== "loading") {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
}


// Custom currency dropdown in mobile menu
onDOMReady(() => {
  const selector = ".slide-nav__currency-selector [data-disclosure-currency]";

  const currencyEl = document.querySelector(selector);
  if (currencyEl) {
    this.currencyDisclosure = new theme.Disclosure(currencyEl);
  }
});
